const toggle = (el, ...classes) => classes.map(e => el.classList.toggle(e))
const remove = (el, ...classes) => classes.map(e => el.classList.remove(e))
const add = (el, ...classes) => classes.map(e => el.classList.add(e))

const _membershipcontent = [
    {
        "plan_id": 42952654651567,
        "product_id": "7620033642671",
        "selling_plan": 1393688751,
        "id": 7620033642671,
        "name": "Scholar",
        "price": "$175/quarter",
        "bullets": [
            "3 Bottle Quarterly Wine Club Allocation w/ Standard Shipping",
            "15% Learn & Earn Rewards",
            "Exclusive Access to Members Only Events",
            "Bring a Friend and Save Discounts",
            "5% Savings on Retail Wine",
            "5% Savings on Your First Registration for Classes & Events as a New Member"
        ],
		"title": "SFWS Scholar Member",
        "handle": "inveterate-subscription-1",
        "first_variant_id": 42952654651567
    },
    {
        "plan_id": 42960441311407,
        "product_id": "7620033216687",
        "selling_plan": 1393655983,
        "id": 7620033216687,
        "name": "Member",
        "price": "$25/quarter",
        "bullets": [
            "10% Learn & Earn Rewards",
            "Exclusive Access to Member's Only Events",
            "Bring a Friend and Save Discounts"
        ],
    	"title": "SFWS Member",
        "handle": "inveterate-subscription",
        "first_variant_id": 42960441311407
    },
    {
        "plan_id": 42960441016495,
        "product_id": "7620034265263",
        "selling_plan": 1393721519,
        "id": 7620034265263,
        "name": "Maestro",
        "price": "$325/quarter",
        "bullets": [
            "6 Bottle Quarterly Wine Club Allocation w/ Standard Shipping",
            "20% Learn & Earn Rewards",
            "Exclusive Access to Members Only Tastings & Events",
            "Bring a Friend and Save Discounts",
            "10% Savings on Retail Wine",
            "10% Savings on Your First Registration for Classes & Events as a New Member"
        ],
		"title": "SFWS Maestro Member",
        "handle": "inveterate-subscription-2",
        "first_variant_id": 42960441016495
    }
];

const themeActions = {
	cart: null,
	debounce: (fn, delay = 500) => {
		let timer = null;
		return function () {
			let context = this;
			let args = arguments;
			clearTimeout(timer);
			timer = setTimeout(function () {
				fn.apply(context, args);
			}, delay);
		};
	},
	convert: (str) => {
		return new Promise(function (resolve, reject) {
			if (typeof str === 'string') {
				const temp = [];
				temp.push(str);
				resolve(temp);
			} else if (typeof str === 'object') {
				resolve(str);
			} else {
				reject(null);
			}
		});
	},
	stringToObject: (string) => {
		if (!string) return;
		const object = JSON.parse(string);
		return object;
	},
	clearLocalStorage: (object) => {
		if (!object) return;
		themeActions.convert(object).then((keysToRemove) => {
			keysToRemove.forEach(key => localStorage.removeItem(key))
		});
	},
	removeItemFromLineItems: (event, id) => {
		// event.preventDefault();
		themeActions.removeLocalStoragePartial(id);
	},
	findLocalStorage: (key) => {
		let results = [];
		for (let i = 0; i < localStorage.length; i++) {
			if (localStorage.key(i).includes(key)) {
				results.push(`${localStorage.key(i)}: ${localStorage.getItem(localStorage.key(i))}`);
			}
		}
		return results;
	},
	removeLocalStorage: (key) => {
		if (!key) return;
		localStorage.removeItem(key);
	},
	removeLocalStoragePartial: (str) => {
		for (let i = 0; i < localStorage.length; i++) {
			if (localStorage.key(i).includes(str)) {
				localStorage.removeItem(localStorage.key(i));
			}
		}
	},
	clearLocalStoragePartials: (str) => {
		const keysToRemove = ['customer-email-', 'customer-phone-', 'first-name-', 'last-name-'];
		keysToRemove.forEach(key => {
			themeActions.removeLocalStoragePartial(key);
			// console.log(key);
		});
	},
	getLocalStorage: (key) => {
		if (!key) return;
		return localStorage.getItem(key) || null;
	},
	setLocalStorage: (key, value) => {
		if (!key || !value) return;
		localStorage.setItem(key, value);
		return value;
	},
	getCartCount: () => {
		return new Promise((resolve, reject) => {
			fetch("/cart.js", {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				},
			})
				.then((result) => result.json())
				.then((result) => {
					resolve(result);
					themeActions.cart = result;
				})
				.catch((error) => {
					reject("failed");
					console.error("Error getCartCount():", error);
				});
		});
	},
	setCartDomElements: (el, cartOutputSelector) => {
		const countSelectors = el ? document.querySelectorAll(el) : document.querySelectorAll("[data-count]");
		const cartOuput = cartOutputSelector ? document.querySelectorAll(cartOutputSelector) : document.querySelectorAll(".js-cart-count-output");
		const cartCount = themeActions.cart?.item_count;

		if (countSelectors) countSelectors.forEach((count) => cartCount && count.setAttribute("data-count", cartCount));

		if (cartOuput) cartOuput.forEach((el) => cartCount && (el.innerHTML = cartCount));
	},
	updateCartCount: (result, el, cartOutputSelector) => {
		if (result) {
			themeActions.setCartDomElements(el, cartOutputSelector);
		} else {
			themeActions.getCartCount(result).then((result) => {
				themeActions.cart = result;
				themeActions.setCartDomElements(el, cartOutputSelector);
			});
		}
	},
	addItemsToCart: (items) => {
		return new Promise((resolve, reject) => {
			fetch(window.Shopify.routes.root + "cart/add", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(items),
			})
				.then((response) => {
					if (response.status === 200) {
						themeActions.getCartCount().then((result) => resolve(result));
					} else {
						reject("failed");
					}
				})
				.catch((error) => {
					reject("failed");
					console.error("Error addItemsToCart():", error);
				});
		});
	},
	addProductToCart: (e, variantId, quantity = 1, keepAdded = true, goToCart = false) => {
		const target = e && e.target;
		if (target && variantId) {
			e.preventDefault();
		} else {
			console.log("missing event: addProductToCart()");
			return false;
		}

		const isLink = target.nodeName === "A" ? true : false;

		target.classList.add("_adding");
		target.classList.remove("_added");

		let items = {
			items: [
				{
					id: Number(variantId),
					quantity: Number(quantity),
				},
			],
		};

		return themeActions
			.addItemsToCart(items)
			.then((result) => {
				target.classList.add("_added");
				target.classList.remove("_adding");

				if (result) themeActions.updateCartCount(result);

				if (goToCart === true) window.location.href = "/cart";

				setTimeout(() => {
					target.classList.remove("tw-cursor-pointer");
					if (isLink) {
						target.setAttribute("href", "/cart");
						target.setAttribute("title", "Go to Cart");
						if (keepAdded) target.classList.add("_go-to-cart");
					} else {
						target.setAttribute("onclick", 'window.location.href="/cart"');

						if (!keepAdded) {
							target.classList.add("!tw-select-none");
							target.classList.add("!tw-cursor-default");
							target.classList.add("!tw-pointer-events-none");
						}
					}

					if (keepAdded === true) target.classList.add("_go-to-cart");

					if (keepAdded === false) target.classList.remove("_added"); // set keepAdded = false to remove persistent "Added to Cart"
				}, 1000);
			})
			.catch((err) => {
				alert("Oops! Something went wrong. \nIf you continue to experience this issue, please contact support.");
				console.log(err);
			});
	},
	init: () => {
		// themeActions.updateCartCount();
	},
};


let cartItems = [];

const getCartItems = () => {
	fetch('/cart.js')
	.then(response => response.json())
	.then(data => {
		cartItems = data.items;
	});
}

// update getCartItems to be a promise and return the cartItems
const getCartItemsPromise = () => {
	return new Promise((resolve, reject) => {
		fetch('/cart.js')
		.then(response => response.json())
		.then(data => {
			cartItems = data.items;
			resolve(cartItems);
		}
		);
	});
}



const checkItemInCart = (id) =>{
	getCartItemsPromise().then((items) => {
		cartItems = items;
		return items
	}). then((data) => {
		// return JSON.parse(data);
		return data;
	}).then((data) => {
		let item = cartItems.find(item => item.variant_id === id);
		if (item) {
			return true
		} else {
			return false
		}
	});
}

const checkItemsInCart = (ids) => {
	return ids.map(id => {
		let item = cartItems.find(item => item.variant_id === id);
		if (item) {
			return true
		} else {
			return false
		}
	});
}

const checkItemsInCartPromise = (ids) => {
	return new Promise((resolve, reject) => {
		resolve(checkItemsInCart(ids));
	});
};


/* Variant Selector */

const quantitySelectOnChange = (event) => {
	if (!event) return;

	const target = event.target;
	const quantity = target.value;
	const quanityInput = document.querySelector(`.quantity-selector__input`);

	if (!quanityInput) return;

	quanityInput.value = Number(quantity);
}


const carouselScroll = {
	parent: document.querySelector('html'),
	disableArrows: (offset = 0) => {
		if (carouselScroll.list.scrollLeft <= 20) {
			carouselScroll.parent.querySelector('button[data-direction="left"]').disabled = true;
		} else {
			carouselScroll.parent.querySelector('button[data-direction="left"]').disabled = false
		}

		if (carouselScroll.list.offsetWidth > 0 && ((carouselScroll.list.scrollLeft + offset) >= carouselScroll.list.offsetWidth)) {
			carouselScroll.parent.querySelector('button[data-direction="right"]').disabled = true;
		} else {
			carouselScroll.parent.querySelector('button[data-direction="right"]').disabled = false;
		}
	},
	scroll: (direction, multiplier = 1) => {

		if (!carouselScroll.list || !carouselScroll.container) return;

		const scrollAmount = carouselScroll.list.children[0].offsetWidth * multiplier;
		const scrollDirection = direction === 'left' ? -1 : 1;


		carouselScroll.container.scrollBy({
			left: scrollAmount * scrollDirection,
			behavior: 'smooth'
		});
		carouselScroll.disableArrows(scrollAmount);
	},
	core: () => {
		carouselScroll.buttons.forEach(button => {
			button.addEventListener('click', (e) => {
				if (!e) return;
				e.preventDefault();

				const target = e.target;
				if (target.dataset.direction === 'left') {
					carouselScroll.scroll('left', target.dataset.multiplier || 1);
				} else {
					carouselScroll.scroll('right', target.dataset.multiplier || 1);
				}
			});
		});
	},
	init: (parent, self = false) => {
		carouselScroll.parent = parent;

		if (!carouselScroll.parent) return;

		if (self === true) {
			setTimeout(() => {
				carouselScroll.list = carouselScroll.parent.querySelector('.carousel-directions__items');
				carouselScroll.container = carouselScroll.parent.querySelector('.carousel-directions__items');
				carouselScroll.buttons = carouselScroll.parent.querySelectorAll('button[data-direction]');

				carouselScroll.core();
			}, 100)
		} else {
			carouselScroll.list = carouselScroll.parent.querySelector('.carousel-directions__items');
			carouselScroll.container = carouselScroll.parent.querySelector('.carousel-directions__items');
			carouselScroll.buttons = carouselScroll.parent.querySelectorAll('button[data-direction]');

			carouselScroll.core();
		}


	}
}


// carouselScroll.init('html');


/**
 * FORMS
 */

// Niceties around typing and pasting in valid email characters (no spaces, etc)

function handleEmailKeyPress(event) {
	const key = event.key;
	const regex = /[a-zA-Z0-9._%+-@]/;
	return regex.test(key);
}

function handleEmailInput(input) {
	input.value = input.value.replace(/\s/g, '');
}

// Niceties around typing and pasting in valid telephone characters (no letters, etc)

function handleTelephoneKeyPress(event) {
	const key = event.key;
	const regex = /[0-9-+() ]/;
	return regex.test(key);
}

let telephonePreviousValue = '';
function handleTelephoneInput(input) {
	const regex = /^[0-9-+() ]*$/;
	if (!regex.test(input.value)) {
		input.value = telephonePreviousValue;
	} else {
		telephonePreviousValue = input.value;
	}
}

const digitsOnly = value => value.replace(/[^\d]/g, "");

const formatPhoneNumber = value => {
	// if input value is falsy eg if the user deletes the input, then just return
	if (!value) return value;

	// clean the input for any non-digit values.
	const phoneNumber = digitsOnly(value);

	// phoneNumberLength is used to know when to apply our formatting for the phone number
	const phoneNumberLength = phoneNumber.length;

	// we need to return the value with no formatting if its less then four digits
	// this is to avoid weird behavior that occurs if you  format the area code to early
	if (phoneNumberLength < 4) return phoneNumber;

	// if phoneNumberLength is greater than 4 and less the 7 we start to return
	// the formatted number
	if (phoneNumberLength < 7) {
		return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
	}

	// finally, if the phoneNumberLength is greater then seven, we add the last
	// bit of formatting and return it.
	return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
		3,
		6
	)}-${phoneNumber.slice(6, 10)}`;
}

const formatPhone = field => {
	field.value = formatPhoneNumber(field.value);
}


const formatPhoneInline = e => {
	const field = e.target;
	field.value = formatPhoneNumber(field.value);
}

function formatDOB(field) {
	let input = digitsOnly(field.value.replaceAll("/", ""));
	input = digitsOnly(input);
	let month = input.substring(0, 2);
	let day = input.substring(2, 4);
	let year = input.substring(4);
	let formatted = `${month}/${day}/${year}`;

	if (input.length <= 2) {
		field.value = input || ""
	} else {
		if (input.length <= 4) {
			formatted = `${month}/${day}`;
			field.value = formatted;
		} else {
			field.value = formatted;
		}
	}

}

const verifyForm = (form, initialLoad = false) => {
	if (!form) return;
	let isValid = form.querySelectorAll('._invalid').length === 0;
	let main = document.querySelector('html');

	if (initialLoad) {
		isValid = false;
	} else {
		const fields = form.querySelectorAll('input, textarea, select');

		fields.forEach(field => {
			verifyField(field)
		})

		isValid = form.querySelectorAll('._invalid').length === 0;

		if (isValid) {
			form.classList.add('_valid');
			form.classList.remove('_invalid');
			main.classList.add('_valid');
			main.classList.remove('_invalid');


		} else {
			form.classList.add('_invalid');
			form.classList.remove('_valid');
			main.classList.add('_invalid');
			main.classList.remove('_valid');
		}
	}


	// if (document.querySelector(".js-modal-close") && isValid) document.querySelector(".js-modal-close").classList.remove('!tw-hidden');

	return isValid;
}
const isNull = val => val === null || val === undefined || val.replaceAll(" ", "") === "";

const verifyField = (field, form = null) => {
	let isValid = field.checkValidity();

	if (isValid) {
		field.classList.remove('_invalid');
		field.classList.add('_valid');
	} else {
		field.classList.remove('_valid');
		field.classList.add('_invalid');
	}

	if (field.required && isNull(field.value)) {
		isValid = false;
		field.classList.add('_invalid');
	}

	if (form) verifyForm(form || document.querySelector(form));
}

const setTextareaHeight = (e = null, field = null) => {
	const textarea = field || e?.target;

	if (!textarea) return;

	textarea.style.minHeight = "auto";
	textarea.style.minHeight = (textarea.scrollHeight / 24) + "em";
}

const growTextarea = () => {
	const textareas = document.querySelectorAll('textarea');

	if (!textareas) return;

	document.querySelectorAll('textarea').forEach(field => {
		field.addEventListener('input', e => setTextareaHeight(e, field));
	});
}





// const fetchMemberDataJson = (ids) => {
// 	console.log("new data");

// 	const membershipDataTimestamp = localStorage.getItem('membershipDataTimestamp');
// 	if (membershipDataTimestamp && new Date().getTime() - membershipDataTimestamp < 10800000) {
// 		console.log("reuse data")
// 		return JSON.parse(localStorage.getItem('membershipData'));
// 	} else {
// 		localStorage.setItem('membershipDataTimestamp', new Date().getTime());
// 		console.log("set timestamp")
// 		console.log("new data");
// 		return fetch(`/products.json?limit=500`)
// 			.then(response => response.json())
// 			.then(data => {
// 				return data.products.filter(product => ids.includes(product.id)).map(product => {
// 					return {
// 						id: product.id,
// 						body_html: product.body_html,
// 						title: product.title,
// 						handle: product.handle,
// 						first_variant_id: product.variants[0].id
// 					};
// 				});

// 			})
// 			.catch(error => console.error(error));
// 	}

// }


// const fetchMemberDataJson = (ids) => {
// 	return new Promise((resolve, reject) => {
// 		resolve(_membershipdata);
// 	});
// }


const addPlanItemStep1 = (id, plan_id, product_id, selling_plan) => {
	// console.log(id)
	addPlanItemStep2(id, plan_id, product_id, selling_plan)
	// fetch('/cart/add.js', {
	// 	body: JSON.stringify({items: [
	// 	  {
	// 		id: id,
	// 		quantity: 1,
	// 	  },
	// 	]}),
	// 	headers: {
	// 	  'Content-Type': 'application/json',
	// 	},
	// 	method: 'POST',
	//   }).then(res => res.json()).then(items => addPlanItemStep2(id) );
}

const addPlanItem = async (id, plan_id, product_id, selling_plan, item) => {

	checkItemsInCartPromise([42952654651567, 42960441311407, 42960441016495]).then((results) => {
		console.log("results", results);
		if (results.includes(true)) {
			alert("Membership already in cart.\nRemove your current membership to add a different plan.");
			item.querySelector("span").innerText = "Add to Cart";
			return false;
		} else {
			fetch('/cart/add.js', {
				body: JSON.stringify({
					items: [
						{
							id: plan_id,
							product_id: product_id,
							quantity: 1,
							selling_plan: selling_plan,
							properties: {
								_inveterate_subscription: true
							},
						},
					]
				}),
				headers: {
					'Content-Type': 'application/json',
				},
				method: 'POST',
			}).then(res => res.json()).then(items => {
				if (window.location.pathname.includes("/cart")) {
					window.location.href = "/cart";
				} else {
					item.querySelector("span").innerText = "Added to Cart";
					getCartItems();
				}
			});
			return true
		}
	});

}



const getMembershipData = (version) => {

	const membershipOutputsTabs = document.getElementById('membershipOutputsTabs');
	const membershipOutputs = document.getElementById('membershipOutputs');



	if (membershipOutputsTabs && membershipOutputs) {


		_membershipcontent.forEach((item, index) => {
			let isInCart = checkItemInCart(item.first_variant_id);

			if (version === 1) {
				const tabs = `<a href="/products/${item?.handle || '#'}" data-trigger="${item.handle}" class=" ${index === 1 ? 'active' : ''} member-tab-click tw-cursor-pointer tw-bg-primary tw-select-none tw-border-1px tw-border-[rgba(15,40,52,0.5)] tw-text-white tw-min-h-30px tw-flex tw-items-center tw-justify-center tw-text-[var(--atlas-text-primary)] tw-font-primary tw-font-primary-bold tw-uppercase tw-text-[1em]">${item?.title?.replace("SFWS", "").replace("Scholar Member", "Scholar").replace("Maestro Member", "Maestro") || "Title"}</a>`;
				const template = `
						<div class="tw-border tw-border-[rgba(15,40,52,0.5)] tw-bg-white tw-hidden tw-mb-5px tw-p-5px tw-flex tw-flex-col member-content ${index === 1 ? 'active' : ''}" data-index="${item.handle}">
							<div class="tw-flex tw-items-center">
								<a href="/products/${item.handle}" class="tw-text-[var(--atlas-text-primary)] tw-font-primary tw-font-primary-bold tw-uppercase tw-text-[.85rem] [&_p]:tw-text-[.7em] tw-w-full tw-text-center tw-flex tw-flex-col tw-items-center"><span class="!tw-text-[#1d1e20]">${item.title}</span></a>
							</div>
							<div class="tw-flex tw-flex-col tw-items-center tw-px-10px tw-gap-10px">
								<span class="tw-flex-grow tw-text-[var(--atlas-text-primary)] tw-font-primary tw-font-primary-normal [&_li]:tw-text-[0.8125rem] tw-text-[rgba(15,40,52,0.7)] [&_.inveterate__pricing__block__heading._h3]:!tw-text-[1.5rem] [&_h3~p]:!tw-text-[0.7rem] tw-leading-[1] [&_h3]:tw-hidden [&_p]:tw-block s[&_p]:tw-text-center [&_p]:tw-flex [&_p]:tw-justify-center [&_p]:tw-font-primary-normal [&_p+*]:tw-pt-10px [&_ul]:!tw-pt-15px">
									<div class="inveterate__pricing__block__upper">
										<div class="inveterate__pricing__block__heading">
											<p><span class="!tw-text-[#1d1e20]">${item.price}</span></p>
										</div>
										<div class="inveterate__pricing__block__bullets">
											<ul class="inveterate__pricing__block__bullets__list">
												${item.bullets.map(bullet => `<li><span class="!tw-text-[#1d1e20]">${bullet}</span></li>`).join('')}
											</ul>
										</div>
									</div>
								</span>
								<div class="tw-flex tw-flex-col tw-items-center tw-px-10px tw-space-y-5px tw-text-center tw-w-full tw-pb-10px">
									<a href="/community/membership/#inveterate-pricing-section" data-id="${item.first_variant_id}" data-plan-id="${item.plan_id}" data-product-id="${item.product_id}" data-selling-plan="${item.selling_plan}" class="${ isInCart === true ? '!tw-pointer-events-none  !tw-cursor-default' : ' tw-cursor-pointer' } add-to-car-tabs tw-bg-secondary tw-px-10px tw-min-h-30px tw-inline-flex tw-items-center tw-justify-center tw-text-white tw-uppercase tw-font-primary tw-font-primary-bold">
										<span class="tw-pointer-events-none">
											${ isInCart === true ? 'Added to Cart' : 'Add Membership' }
										</span>
									</a>
									<a href="/community/membership/#inveterate-pricing-section" class="tw-text-primary tw-text-[.85em] tw-cursor-pointer tw-no-underline hover:tw-underline tw-px-10px tw-min-h-20px tw-inline-flex tw-items-center tw-justify-center tw-font-primary tw-font-primary-normal">
										<span class="tw-pointer-events-none tw-w-full tw-text-center">Learn More</span>
									</a>
								</div>
							</div>
						</div>
					`;
				membershipOutputsTabs.insertAdjacentHTML('beforeend', tabs);
				membershipOutputs.insertAdjacentHTML('beforeend', template);

			} else {
				const tabs = `<a href="/products/${item?.handle || '#'}" data-trigger="${item.handle}" class=" ${index === 1 ? 'active' : ''} member-tab-click tw-cursor-pointer tw-bg-primary-accent tw-relative tw-z-2 tw-select-none tw-border-1px tw-border-primary-dark tw-text-white tw-min-h-30px tw-flex tw-items-center tw-justify-center tw-text-[var(--atlas-text-primary)] tw-font-primary tw-font-primary-bold tw-uppercase tw-text-[.8em]">${item?.title?.replace("SFWS", "").replace("Scholar Member", "Scholar").replace("Maestro Member", "Maestro") || "Title"}</a>`;
				const template = `
						<div class="tw-border tw-border-primary-dark tw-bg-white tw-hidden tw-mb-5px tw-p-5px X[&_p]:tw-hidden tw-flex tw-flex-col member-content ${index === 1 ? 'active' : ''}" data-index="${item.handle}">
							<div class="tw-flex tw-items-center">
								<a href="/products/${item.handle}" class="tw-text-[var(--atlas-text-primary)] tw-font-primary tw-font-primary-bold tw-uppercase tw-text-[.9em] tw-w-full tw-text-center tw-flex tw-flex-col tw-items-center"><span class="!tw-text-[#1d1e20]">${item.title}</span></a>
							</div>
							<div class="tw-flex tw-flex-col tw-items-start tw-px-10px tw-gap-10px">
								<div class="tw-block tw-w-full tw-flex-grow tw-text-[var(--atlas-text-primary)] tw-font-primary tw-font-primary-normal tw-text-[.9em] tw-leading-[1] [&_h3~p]:!tw-text-[0.7rem] [&_h3]:tw-hidden [&_p]:tw-block [&_p]:tw-text-center [&_p]:tw-flex [&_p]:tw-justify-center [&_p]:tw-font-primary-normal [&_p+*]:tw-pt-10px [&_ul]:!tw-pt-15px">
									<div class="inveterate__pricing__block__upper">
										<div class="inveterate__pricing__block__heading">
											<p class="!tw-text-[#1d1e20]"><span class="!tw-text-[#1d1e20]">${item.price}</span></p>
										</div>
										<div class="inveterate__pricing__block__bullets">
											<ul class="inveterate__pricing__block__bullets__list">
												${item.bullets.map(bullet => `<li class="!tw-text-[#1d1e20]"><span class="!tw-text-[#1d1e20]">${bullet}</span></li>`).join('')}
											</ul>
										</div>
									</div>
								</div>
							</div>
							<div class="tw-flex tw-flex-col tw-items-center tw-px-10px tw-space-y-5px tw-text-center tw-w-full tw-pb-10px tw-pt-15px">
								<a href="/community/membership/#inveterate-pricing-section" data-id="${item.first_variant_id}" data-plan-id="${item.plan_id}" data-product-id="${item.product_id}" data-selling-plan="${item.selling_plan}" class="${ isInCart === true ? '!tw-pointer-events-none  !tw-cursor-default' : ' tw-cursor-pointer' } add-to-car-tabs tw-bg-secondary tw-px-10px tw-min-h-30px tw-inline-flex tw-items-center tw-justify-center tw-text-white tw-uppercase tw-font-primary tw-font-primary-bold">
									<span class="tw-pointer-events-none">
										${ isInCart === true ? 'Added to Cart' : 'Add Membership' }
									</span>
								</a>

								<a href="/community/membership/#inveterate-pricing-section" class="tw-text-primary tw-text-[.85em] tw-cursor-pointer tw-no-underline hover:tw-underline tw-px-10px tw-min-h-20px tw-inline-flex tw-items-center tw-justify-center  tw-font-primary tw-font-primary-normal">
									<span class="tw-pointer-events-none tw-w-full tw-text-center">Learn More</span>
								</a>
							</div>
						</div>
					`;
				membershipOutputsTabs.insertAdjacentHTML('beforeend', tabs);
				membershipOutputs.insertAdjacentHTML('beforeend', template);
			}
		});

		setTimeout(() => {
			const memberTabClick = document.querySelectorAll(".add-to-car-tabs");
			if (memberTabClick) {
				memberTabClick.forEach(item => {
					item.addEventListener('click', (e) => {
						e.preventDefault();
						addPlanItem(Number(item.getAttribute('data-id')), Number(item.getAttribute('data-plan-id')), item.getAttribute('data-product-id'), Number(item.getAttribute('data-selling-plan')), item);
						item.querySelector("span").innerText = "Adding...";
					});
				})
			}
		}, 150);

		const memberTabClick = document.querySelectorAll(".member-tab-click");
		if (memberTabClick) {
			memberTabClick.forEach(tab => {
				// console.log(tab);
				tab.addEventListener("click", (e) => {
					e.preventDefault();
					const trigger = e.target.getAttribute("data-trigger");
					document.querySelectorAll(".member-tab-click").forEach(tab => {
						tab.classList.remove("active");
					});
					document.querySelectorAll(".member-content").forEach(content => {
						content.classList.remove("active");
					});
					document.querySelector(`[data-index="${trigger}"]`).classList.add("active");
					e.target.classList.add("active");
				});
			});
		}

	}
}



if (window.location.pathname === '/community/membership' || window.location.pathname === '/community/membership/') { // update if the page url is also "community/membership/#inveterate-pricing-section"
    document.addEventListener('DOMContentLoaded', () => {
        const cart = document.querySelector('.inveterate__cart');
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    if (cart.classList.contains('inveterate__visible')) {
                        // window.location.href = '/cart';
                    }
                }
            });
        });
        observer.observe(cart, {
            attributes: true,
        });
    });
}


function checkCart() {
    var cartCount = document.querySelector("html").getAttribute('data-cart-count');
    if (cartCount && Number(cartCount) === 0) {
        // console.log("Cart is empty", cartCount);
		themeActions.clearLocalStoragePartials()
    } else {
        // console.log("Cart is not empty", cartCount);
    }
}

document.addEventListener('DOMContentLoaded', () => {
	checkCart();
});
